import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { MusicLinks } from 'components/music-links'
import { ThreadWrapper, Title } from './styled'

export const Music = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref}>
    <Title data-menu-title="современная музыка">
      <TextContainer>Современная музыка</TextContainer>
    </Title>
    <TextContainer>
      <p>
        В последние годы в Татарстане развилось яркое альтернативное музыкальное
        движение, которое смогло выйти далеко за границы не только региона, но и
        России. Сегодня музыканты работают в самых разнообразных жанрах: рэп,
        синти-поп, инди, экспериментальная электроника, кто-то переосмысливает
        уже известные хиты – вроде вирусного ролика "Татарстан супергуд". Мы
        собрали подборку самых ярких представителей новой татарстанской
        музыкальной сцены:
      </p>
    </TextContainer>

    <ThreadWrapper>
      <MusicLinks link="https://music.youtube.com/playlist?list=PL2LCM5HET2Haknwb16baWpqOMngbWLclI">
        <span>слушать</span> в YT Music
      </MusicLinks>
    </ThreadWrapper>
  </section>
))
